import React from "react";
import Skeleton from 'react-loading-skeleton';

const ViewUserSkeleton = _ => {

    return <div className="container">
                <div className="row">
                    <div className="col-lg-9">
                        <div className="card card-custom gutter-b  card-stretch">
                            <div className="card-header h-auto border-0 px-2">
                                {/* <!--begin::Title--> */}
                                <div className="card-title w-100 pt-5">
                                    <h3 className="card-label w-100 row">
                                        <span className="text-muted font-weight-bolder col-md-3"><Skeleton /></span>
                                        <div className="col text-right">
                                                <Skeleton  width="5%" count="8" className="ml-3" />
                                            </div>
                                        </h3>
                                </div>
                                {/* <!--end::Title--> */}
                            </div>
                            {/* <!--begin::Body--> */}
                            <div className="card-body pt-2 px-1">
                                {/* <!--begin::Item--> */}
                                <div className="d-flex flex-column my-5 px-5">
                                    <Skeleton height="400px" />
                                </div>
                                {/* <!--end::Item--> */}
                                
                            </div>
                            {/* <!--end::Body--> */}
                        </div>
                    </div>
                    <div className="col-lg-3 mt-4 mt-lg-0">
                        <div className="card card-custom gutter-b  card-stretch">
                            <div className="py-5 px-8">
                                <Skeleton height="22px" />
                            </div>
                            {/* <!--begin::Body--> */}
                            <div className="card-body pt-0">
                                {/* <!--begin::Item--> */}
                                <div className="d-flex flex-column mt-0">
                                    {/* <!--begin::Field--> */}
                                    <Skeleton count="15" height="20px" className="mb-2" />
                                </div>
                                {/* <!--end::Item--> */}
                                
                            </div>
                            {/* <!--end::Body--> */}
                        </div>
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-lg-3">
                        <div className="card card-custom gutter-b  card-stretch">
                            <div className="py-5 px-8">
                                <Skeleton height="22px" />
                            </div>
                            {/* <!--begin::Body--> */}
                            <div className="card-body pt-0">
                                {/* <!--begin::Item--> */}
                                <div className="d-flex flex-column mt-0">
                                    {/* <!--begin::Field--> */}
                                    <Skeleton count="8" height="20px" className="mb-2" />
                                </div>
                                {/* <!--end::Item--> */}
                                
                            </div>
                            {/* <!--end::Body--> */}
                        </div>
                    </div>
                    <div className="col-lg mt-4 mt-lg-0">
                        <div className="card card-custom gutter-b  card-stretch">
                            <div className="py-5 px-8">
                                <Skeleton height="22px" />
                            </div>
                            {/* <!--begin::Body--> */}
                            <div className="card-body pt-0 px-lg-2">
                                {/* <!--begin::Item--> */}
                                <div className="d-flex flex-column mt-4 px-5">
                                    <Skeleton height="250px" />
                                </div>
                                {/* <!--end::Item--> */} 
                            </div>
                            {/* <!--end::Body--> */}
                        </div>
                    </div>
                    <div className="col-lg mt-4 mt-lg-0">
                        <div className="card card-custom gutter-b  card-stretch">
                            <div className="py-5 px-8">
                                <Skeleton height="22px" />
                            </div>
                            {/* <!--begin::Body--> */}
                            <div className="card-body pt-0 px-lg-2">
                                {/* <!--begin::Item--> */}
                                <div className="d-flex flex-column mt-4 px-5">
                                    <Skeleton height="250px" />
                                </div>
                                {/* <!--end::Item--> */} 
                            </div>
                            {/* <!--end::Body--> */}
                        </div>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-lg-5">
                        <div className="card card-custom gutter-b  card-stretch">
                            <div className="py-5 px-8">
                                <Skeleton height="22px" />
                            </div>
                            {/* <!--begin::Body--> */}
                            <div className="card-body pt-0 pr-4">
                                {/* <!--begin::Item--> */}
                                <div className="d-flex flex-column mt-0 overflow-auto px-5" style={{height: "400px"}}>
                                    <Skeleton height="180px" count="2" className="mb-2" />
                                </div>
                                {/* <!--end::Item--> */}
                                
                            </div>
                            {/* <!--end::Body--> */}
                        </div>
                    </div>
                    <div className="col-lg mt-4 mt-lg-0">
                        <div className="card card-custom gutter-b  card-stretch">
                            <div className="py-5 px-8">
                                <Skeleton height="22px" />
                            </div>
                            {/* <!--begin::Body--> */}
                            <div className="card-body pt-0">
                                {/* <!--begin::Item--> */}
                                <div className="d-flex flex-column mt-0 px-4 overflow-auto" style={{height: "400px"}}>
                                    <Skeleton height="20px" width="30%" count="24" className="mx-2 my-4" />
                                </div>
                                {/* <!--end::Item--> */}
                                
                            </div>
                            {/* <!--end::Body--> */}
                        </div>
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col">
                        <div className="card card-custom gutter-b  card-stretch">
                            <div className="py-5 px-8">
                                <Skeleton height="22px" />
                            </div>
                            {/* <!--begin::Body--> */}
                            <div className="card-body pt-0">

                                <h4><Skeleton  /></h4>
                                <p><Skeleton height="200px" /></p>
                                <div className="row">
                                    <div className="col-lg">
                                        <Skeleton height="20px" />
                                    </div>
                                    <div className="col-lg">
                                        <Skeleton height="20px" />
                                    </div>
                                    <div className="col-lg">
                                        <Skeleton height="20px" />
                                    </div>
                                </div>
                                

                            </div>
                            {/* <!--end::Body--> */}
                        </div>
                    </div>
                </div>
            </div>
  }

export default ViewUserSkeleton;

